// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"501":"96b0cb50","2320":"c0ada95f","4141":"253c14e2","5180":"c0ada95f","6375":"a397af0e","7463":"b34400a1","9247":"b4342d58"}[chunkId] + ".chunk.css";
};